import ContactMe from '../components/contactme/ContactMe';
import AboutMe from '../components/aboutme/AboutMe';
import MyProjects from '../components/myprojects/MyProjects';
import MyTeam from '../components/myteam/MyTeam';
import Home from '../views/Home';
import Login from '../views/Login';
import Signup from '../views/Signup';


let routes = [
	{
		path: '/login',
		component: Login,
		layout: 'auth',
	},
	{
		path: '/signup',
		component: Signup,
		layout: 'auth',
	},
	{
		path: '/',
		component: Home,
		layout: 'main',
	},
	{
		path: '/about-me',
		component: AboutMe,
		layout: 'main',
	},
	{
		path: '/my-projects',
		component: MyProjects,
		layout: 'main',
	},
	{
		path: '/my-team',
		component: MyTeam,
		layout: 'main',
	},
	{
		path: '/contact-me',
		component: ContactMe,
		layout: 'main',
	},
];
export default routes;